import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = () => (
  <div className="loading-spinner-overlay">
    <div className="loading-spinner-content">
      <div className="loading-logo-wrapper">
        <img src="/mega.png" alt="MegaGenie" className="loading-logo" />
        <div className="loading-ring"></div>
      </div>
      <p className="loading-brand">MEGA GENIE</p>
    </div>
  </div>
);

export default LoadingSpinner;
